import {createMediaSignals} from '@pexip/media';
import {createSignal} from '@pexip/signal';

export const pushToTalkSignal = createSignal<boolean>({
    name: 'media:unmute:actions',
});

export const mediaSignals = createMediaSignals(
    [
        'onAddTrack',
        'onAudioMuteStateChanged',
        'onDevicesChanged',
        'onRemoveTrack',
        'onStatusChanged',
        'onStreamTrackEnabled',
        'onStreamTrackEnabledFinal',
        'onStreamTrackEnded',
        'onStreamTrackEndedFinal',
        'onStreamTrackMuted',
        'onStreamTrackMutedFinal',
        'onStreamTrackUnmuted',
        'onStreamTrackUnmutedFinal',
        'onVideoMuteStateChanged',
    ],
    'infinity-connect',
);
